import { render, staticRenderFns } from "./navigation-bar.vue?vue&type=template&id=1a54d14f&scoped=true&"
import script from "./navigation-bar.vue?vue&type=script&lang=js&"
export * from "./navigation-bar.vue?vue&type=script&lang=js&"
import style0 from "./navigation-bar.vue?vue&type=style&index=0&id=1a54d14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54d14f",
  null
  
)

export default component.exports